export default "__VITE_ASSET__zQ77auv0__"